import { createStyles } from '@mui/styles';

export const tableStyles = createStyles({
  root: {
    borderSpacing: '0 6px',
    borderTopColor: 'grey.30',
    borderTopStyle: 'solid',
    borderTopWidth: '1px',
    boxSizing: 'border-box',
    width: '100%',
    overflow: 'visible',

    '& thead tr th': {
      color: 'grey.50',
      fontSize: '14px',
      fontWeight: 400,
      letterSpacing: '0.08px',
      lineHeight: '16px',
      padding: '16px',
      textAlign: 'left',
      userSelect: 'none',
    },

    '& tbody tr': {
      background: 'white',
      cursor: 'pointer',
      height: '56px',
      padding: '12px 16px',

      '&:hover': {
        position: 'relative',
        boxShadow: `0px 24px 38px rgba(80, 86, 94, 0.04), 0px 9px 46px rgba(80, 86, 94, 0.04), 0px 11px 15px rgba(80, 86, 94, 0.1);`,
      },
    },

    '& tbody td': {
      background: 'inherit',
      height: 'inherit',
      padding: 'inherit',
    },

    '& tbody tr > :first-child': {
      borderRadius: '6px 0 0 6px',
    },

    '& tbody tr > :last-child': {
      borderRadius: '0 6px 6px 0',
    },
  },
});
